!function(e){"use strict";"function"==typeof define&&define.amd?define("jquery/ui-modules/jquery-var-for-color",["jquery","./version"],e):e(jQuery)}(function(e){"use strict"});
